// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Sa7Z","selected":"Chip_selected__3gkKO"};